import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { LicenseTierDto } from '../../generated-types/licenseTierDto';

/**
 * The properties for the pricing table
 */
interface PricingTableProps {
  /**
   * The tiers for the licenses
   */
  licenseTiers: LicenseTierDto[];
  /**
   * (Optional) The elevation for the card. Defaults to 5.
   */
  elevation?: number;
  /**
   * (Optional) The variant fo the card. Defaults to elevation.
   */
  variant?: 'outlined' | 'elevation';
}

/**
 * A component to display the S3G prices
 */
const PricingTable = (props: PricingTableProps) => {
  return (
    <TableContainer
      component={Paper}
      elevation={props.elevation ?? 5}
      variant={props.variant ?? 'elevation'}
      sx={{
        position: 'sticky',
        top: '1em',
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>License Count</TableCell>
            <TableCell>Price per license, per year</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.licenseTiers.map((t, i) => (
            <TableRow key={i}>
              <TableCell>
                {t.min}
                {i + 1 < props.licenseTiers.length
                  ? `-${props.licenseTiers[i + 1].min - 1}`
                  : '+'}
              </TableCell>
              <TableCell>${t.yearlyPrice.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PricingTable;
